/**
 * Cross-resource inbox of workflow approvals waiting for the current
 * user. Mounted at `/workflows/pending-approvals` (Plan D §3).
 */

import { PendingApprovalsList } from '@/shared/components/workflows'

export function PendingApprovalsPage() {
  return (
    <div className="flex flex-col gap-4 p-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">
          Pending approvals
        </h1>
        <p className="text-sm text-muted-foreground">
          Workflow actions submitted for second-approver review.
        </p>
      </header>
      <PendingApprovalsList />
    </div>
  )
}
